/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable no-unused-vars */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Stack from "@mui/material/Stack";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import SubTitleContents from "reusables/TextFormats/SubTitleContents";

// Images
import logo from "assets/images/Spechs_logo/logo_no_text_transparent.png";

function AboutUs_Section1() {
  const lineSpacing_lg = <MKBox mb={12} />;
  const lineSpacing_sm = <MKBox mb={2} />;
  return (
    <Container>
      <SubTitleContents
        title="About SPECHS"
        contents={
          <>
            <Grid container alignItems="center" width={"100%"}>
              <Grid item xs={12} lg={9}>
                We’ve steadily grown our business, adding new services each year to cater to the
                diverse needs of both domestic and commercial clients. Understanding that every
                client is unique, we provide bespoke plans tailored to your specific requirements.
                Whether you need a one-off service or regular support, our solutions are designed to
                suit your needs and budget.
                {lineSpacing_sm}
                At Spechs, we believe that a clean and organised environment is vital for a healthy
                and happy lifestyle. Our commitment is to deliver services that consistently exceed
                expectations.
                {lineSpacing_sm}
                Get in touch with us today to learn more about what we offer or to book your
                appointment. We look forward to working with you!
              </Grid>
              <Grid item xs={12} lg={3}>
                <MKBox
                  component="img"
                  src={logo}
                  alt={"Spech Logo"}
                  width="100%"
                  pl={7}
                  position="relative"
                />
              </Grid>
            </Grid>
          </>
        }
      />
    </Container>
  );
}

export default AboutUs_Section1;
